import React from 'react';

import Error404 from './Error404';
import Error500 from './Error500';

const ErrorMsgWrapper = ({ errorCode }: { errorCode?: string | number }) => (
  <>
    {errorCode == '404' && <Error404 />}
    {(!errorCode || errorCode != '404') && <Error500 />}
  </>
);

export default ErrorMsgWrapper;
